import { createSelector } from '@reduxjs/toolkit';

const SET_DEVICES = 'bleService/SET_DEVICES';
const SET_SELECTED_DEVICE = 'bleService/SET_SELECTED_DEVICE';
const UPDATE_CONNECTION_STATUS = 'bleService/UPDATE_CONNECTION_STATUS';
const SET_DEVICE_INFO = 'bleService/SET_DEVICE_INFO';
const SET_CENTRAl_STATE_STATUS = 'bleService/SET_CENTRAl_STATE_STATUS';

const initialState = {
    devices: [],
    selectedDevice: null,
    centralStateStatus: null,
};

// actions

export const setDevices = (data: any) => ({
    type: SET_DEVICES,
    payload: { data },
});

export const setSelectedDevice = (device: any) => ({
    type: SET_SELECTED_DEVICE,
    payload: { device },
});

export const updateDeviceConnectionStatus = (deviceId: any, connectionStatus: any) => ({
    type: UPDATE_CONNECTION_STATUS,
    payload: { deviceId, connectionStatus },
});

export const setDeviceInfo = (deviceId: any, deviceInfo: any) => ({
    type: SET_DEVICE_INFO,
    payload: { deviceId, deviceInfo },
});

export const setCentralStateStatus = (status: any) => ({
    type: SET_CENTRAl_STATE_STATUS,
    payload: { status },
});


// reducer
export default function bleServiceReducer(state = initialState, action: any) {
    switch (action.type) {
        case SET_DEVICES:
            const data = action.payload.data;
            
            const updatedDevices = [
                ...state.devices,
                ...data.filter(
                    (newDevice: any) => !state.devices.some((device: any) => device.id === newDevice.id)
                )
            ];
        
            return {
                ...state,
                devices: updatedDevices,
            };


        case SET_SELECTED_DEVICE:
            const device = action.payload.device;
            return {
                ...state,
                selectedDevice: device,
            };
        case UPDATE_CONNECTION_STATUS:
            return {
                ...state,
                devices: state.devices.map((device: any) =>
                    device.id === action.payload.deviceId
                        ? { ...device, connectionStatus: action.payload.connectionStatus }
                        : device
                ),
            };
        case SET_DEVICE_INFO:
            return {
                ...state,
                devices: state.devices.map((device: any) =>
                    device.id === action.payload.deviceId
                        ? { ...device, info: action.payload.deviceInfo }
                        : device
                ),
            };
        case SET_CENTRAl_STATE_STATUS:
            return {
                ...state,
                centralStateStatus: action.payload.status,
            };
        default:
            return state;
    }
}

// selectors
export const getDevices = (state: any) => state.bleService.devices;
export const getSelectedDevice = (state: any) => state.bleService.selectedDevice;
export const getDeviceConnectionStatusById = (deviceId: string) => createSelector(
    getDevices,
    (devices) => {
        const device = devices.find((device: any) => device.id === deviceId);
        return device?.connectionStatus;
    }
);
export const getDeviceInfoById = (deviceId: string) => createSelector(
    getDevices,
    (devices) => {
        const device = devices.find((device: any) => device.id === deviceId);
        return device?.info;
    }
);
export const getCentralStateStatus = (state: any) => state.bleService.centralStateStatus;